import { useIsAuthenticated } from './use-is-authenticated'
import {
  selectUserGroupId,
  selectIsGroupOwner,
  selectUserGroupVersion,
  selectAcceptedTermsAt,
} from '../state/dashboard/dashboard.slice'
import { useAppSelector } from '../state/rootReducer'

export enum USER_TYPE {
  NEW_USER,
  SOLO_USER,
  GROUP_V1_MEMBER,
  GROUP_V1_OWNER,
  GROUP_V2_MEMBER,
  GROUP_V2_OWNER,
}

export const useUserGroup = (): USER_TYPE => {
  const isAuthenticated = useIsAuthenticated()
  const groupId = useAppSelector(selectUserGroupId)
  const isOwner = useAppSelector(selectIsGroupOwner)
  const groupVersion = useAppSelector(selectUserGroupVersion)
  const acceptedTermsAt = useAppSelector(selectAcceptedTermsAt)

  if (!isAuthenticated) {
    return USER_TYPE.NEW_USER
  } else if (groupId && groupVersion === 1 && acceptedTermsAt) {
    if (isOwner) {
      return USER_TYPE.GROUP_V1_OWNER
    } else {
      return USER_TYPE.GROUP_V1_MEMBER
    }
  } else if (groupId && groupVersion === 2 && acceptedTermsAt) {
    if (isOwner) {
      return USER_TYPE.GROUP_V2_OWNER
    } else {
      return USER_TYPE.GROUP_V2_MEMBER
    }
  } else {
    return USER_TYPE.SOLO_USER
  }
}
